module.exports = __webpack_public_path__ + "media/music/drumkit_3-82ad4bdf.mp3";